export default __webpack_public_path__ + "static/step1-326991cada19a73aeded0b5d22a8e5a3.png";